import { onMounted, onUnmounted, type Ref } from "vue";

export function useRevealOnScroll(target: Ref<HTMLElement | null>): void {
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    const el = target.value;
    if (!el) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          observer?.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
  });

  onUnmounted(() => {
    observer?.disconnect();
  });
}
